import Layout from '@/layout';
var pageDiyRouter = {
  path: '/design',
  component: Layout,
  redirect: '/design/index',
  name: 'PageDiy',
  meta: {
    title: '装修',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    name: 'designIndex',
    alwaysShow: true,
    component: function component() {
      return import('@/views/pagediy/devise/index');
    },
    meta: {
      title: '店铺装修',
      roles: ['admin']
    }
  }]
};
export default pageDiyRouter;